/**
 * Formats a US phone number string for display: (555) 123-4567
 * Strips non-digits, handles +1 country code prefix.
 * Returns the original string unchanged if it can't be formatted to 10 digits.
 */
export const formatPhoneNumberDisplay = (phone: string | undefined): string | undefined => {
	if (!phone) {
		return undefined;
	}

	const digitsOnly = phone.replace(/\D/g, '');

	// Strip leading US country code
	let phoneDigits = digitsOnly;
	if (digitsOnly.length === 11 && digitsOnly.startsWith('1')) {
		phoneDigits = digitsOnly.slice(1);
	}

	if (phoneDigits.length === 10) {
		const areaCode = phoneDigits.slice(0, 3);
		const middleThree = phoneDigits.slice(3, 6);
		const lastFour = phoneDigits.slice(6, 10);
		return `(${areaCode}) ${middleThree}-${lastFour}`;
	}

	return phone;
};
